import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_CAN_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CanRefuelings from '../../components/Refuelings/CanRefuelings';

export const Route = createFileRoute('/_authenticated/can-refuelings/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_CAN_REFUELING, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.canRefuelingsOverview',
        suffix: 'menu.refuelings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CanRefuelingsRoute,
});

function CanRefuelingsRoute() {
  return <CanRefuelings />;
}
